import * as actionTypes from '../../actions/actionTypes';

const initialState = {
    diplomaInfo: [],
    loadingDiplomaInfo: false,

    availableTopics: [],
    loadingAvailableTopics: false,

    sendingDiplomaRequest: false,
    errorOnSendDiplomaRequest: false,

    deletingDiplomaRequest: false,
    errorOnDeleteDiplomaRequest: false
};

////////////////////////////////////////////////////////////////

const loadDiplomaInfo = (state) => {
    return {
        ...state,
        loadingDiplomaInfo: true
    }
}

const setDiplomaInfo = ( state, action ) => {
    let tmp = [...action.diplomaInfo]
    return {
        ...state,
        diplomaInfo: tmp,
        loadingDiplomaInfo: false
    }
};

////////////////////////////////////////////////////////////////

const loadDiplomaAvailableTopics = (state) => {
    return {
        ...state,
        loadingAvailableTopics: true
    }
}

const setDiplomaAvailableTopics = ( state, action ) => {
    let tmp = [...action.availableTopics]
    return {
        ...state,
        availableTopics: tmp,
        loadingAvailableTopics: false
    }
};

////////////////////////////////////////////////////////////////

const sendDiplomaRequest = (state) => {
    return {
        ...state,
        sendingDiplomaRequest: true
    }
}

const receiveDiplomaRequestResultOnSuccess = (state, action) => {
    let requests = state.diplomaInfo;
    requests.unshift(action.newDiplomaRequest);

    return {
        ...state,
        sendingDiplomaRequest: false,
        diplomaInfo: requests,
        errorOnSendDiplomaRequest: false
    }
}

const receiveDiplomaRequestResultOnError = (state) => {

    return {
        ...state,
        sendingDiplomaRequest: false,
        errorOnSendDiplomaRequest: true
    }
}

////////////////////////////////////////////////////////////////

const deleteDiplomaRequest = (state) => {
    return {
        ...state,
        deletingDiplomaRequest: true,
        errorOnDeleteDiplomaRequest: false
    }
}

const onDeleteDiplomaRequestSuccess = (state, action) => {
    let requests = state.diplomaInfo;
    let deletedRequestId = action.requestId;

    for (let i = 0; i < requests.length; i++) {
        if (requests[i].id === deletedRequestId) {
            requests.splice(i, 1);
            break;
        }
    }

    return {
        ...state,
        deletingDiplomaRequest: false,
        errorOnDeleteDiplomaRequest: false,
        diplomaInfo: requests
    }
}

const onDeleteDiplomaRequestError = (state) => {

    return {
        ...state,
        deletingDiplomaRequest: false,
        errorOnDeleteDiplomaRequest: true
    }
}

////////////////////////////////////////////////////////////////

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.LOAD_DIPLOMA_INFO: return loadDiplomaInfo( state );
        case actionTypes.SET_DIPLOMA_INFO: return setDiplomaInfo( state, action );

        case actionTypes.LOAD_DIPLOMA_AVAILABLE_TOPICS: return loadDiplomaAvailableTopics( state );
        case actionTypes.SET_DIPLOMA_AVAILABLE_TOPICS: return setDiplomaAvailableTopics( state, action );

        case actionTypes.SEND_DIPLOMA_REQUEST: return sendDiplomaRequest( state );
        case actionTypes.RECEIVE_DIPLOMA_REQUEST_RESULT_ON_SUCCESS: return receiveDiplomaRequestResultOnSuccess( state, action );
        case actionTypes.RECEIVE_DIPLOMA_REQUEST_RESULT_ON_ERROR: return receiveDiplomaRequestResultOnError( state );

        case actionTypes.DELETE_DIPLOMA_REQUEST: return deleteDiplomaRequest( state );
        case actionTypes.STOP_DELETING_DIPLOMA_REQUEST_ON_SUCCESS: return onDeleteDiplomaRequestSuccess( state, action );
        case actionTypes.STOP_DELETING_DIPLOMA_REQUEST_ON_ERROR: return onDeleteDiplomaRequestError( state );

        default: return state;
    }
};
export default reducer;